import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { GlobalStyleFooter, EmptyNameText } from '../styles';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle } from '@fortawesome/pro-regular-svg-icons/faExclamationTriangle';
var TemplateSelectMessage = function () {
    return (_jsxs(GlobalStyleFooter, { children: [_jsx(FontAwesomeIcon, { color: "#f2994a", size: "sm", icon: faExclamationTriangle }), ' ', _jsx(EmptyNameText, { children: "Please select a template to continue" })] }));
};
export default TemplateSelectMessage;
